import { FormModel } from '../core/form-model.class';
import { FrontCreateUserDto } from './create-user.dto';

export class UserFormModel extends FormModel(FrontCreateUserDto) {
    public labels: any = {
        active: 'Actif',
        firstname: 'Prénom',
        lastname: 'Nom',
        email: 'Email',
        password: 'Mot de passe',
        entity: 'Entité',
        job: 'Fonction',
        role: 'Rôle',
        agencyId: 'Agence',
    };
}
